import { render, staticRenderFns } from "./EditCustomerAcc.vue?vue&type=template&id=39b8594c&scoped=true"
import script from "./EditCustomerAcc.vue?vue&type=script&lang=js"
export * from "./EditCustomerAcc.vue?vue&type=script&lang=js"
import style0 from "./EditCustomerAcc.vue?vue&type=style&index=0&id=39b8594c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8594c",
  null
  
)

export default component.exports